const buttons = document.querySelectorAll('.js-tabs-btn')
const contents = document.querySelectorAll('.js-tabs-content')

if (buttons.length > 0) {
  let active = 0
  buttons.forEach((btn,index) => {
    btn.addEventListener('click', () => {
      if (index !== active) {
        buttons[active].classList.remove('is-active')
        contents[active].classList.remove('is-active')
        btn.classList.add('is-active')
        contents[index].classList.add('is-active')
        active = index
      }
    })
  })
}